"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterParams = void 0;
var _react = require("react");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useFilterParams = exports.useFilterParams = function useFilterParams(items, query) {
  var ref = (0, _react.useRef)({});
  var params = (0, _react.useMemo)(function () {
    var instance = {};
    items.forEach(function (item) {
      var value = query.get(item.name);
      if (value !== null && value !== '') {
        instance = Object.assign(Object.assign({}, instance), _defineProperty({}, item.name, value));
      }
    });
    if (!ref.current) {
      ref.current = instance;
      return instance;
    }
    if (Object.keys(ref.current).length !== Object.keys(instance).length) {
      ref.current = instance;
      return instance;
    }
    var current = ref.current;
    var recent = instance;
    for (var _i = 0, _Object$keys = Object.keys(current); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (current[key] !== recent[key]) {
        ref.current = instance;
        return instance;
      }
    }
    return ref.current;
  }, [items, query]);
  return params;
};